<template>
    <Modal
        :show="show"
        :title="modalTitle"
        :size="size"
        :needFooter="false"
        :needHeader="true"
        :centered="true"
        :closeBtn="true"
        class="panel-featureable-gallery"
        modalClass="modal-responsive"
        @close="onClose">
        <div class="row">
            <div class="col-12">
                <LayerFeatureableGallery
                    :show="show"
                    :textHeader="textHeader"
                    :groups="groups"
                    :cardGroupClass="cardGroupClass"
                    @selected="onSelected"
                />
            </div>
        </div>
    </Modal>
</template>

<script>

export default {
    name: 'PanelLayerFeatureableGallery',
    components: {
        Modal: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal.vue'),
        LayerFeatureableGallery: () => import(/* webpackChunkName: "layer-featureable-gallery" */ './elements/LayerFeatureableGallery.vue'),
    },
    mixins: [

    ],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'responsive',
        },
        title: {
            type: String,
            default: null,
        },
        panelID: {
            type: String,
            default: 'featureable',
        },
        textHeader: {
            type: String,
            default: null,
        },
        groups: {
            type: Array,
            default: () => {
                return [];
            },
        },
        cardGroupClass: {
            type: String,
            default: 'card-columns',
        },
    },
    data() {
        return {
            pageID: this.panelID,
        }
    },
    computed: {
        modalTitle() {
            return this.title ?? `${this.pageID}.title`;
        },
    },
    methods: {
        initialize: function() {
        },
        reset: function() {
            // Object.assign(this.$data.form, this.$options.data().form);
        },
        onSelected: function(params = {}) {
            this.$emit('selected', params);
        },
        onClose: function() {
            this.$emit('close')
        },
    },
    watch: {
        show: {
            handler: function(newValue, oldValue) {
                if(newValue) {
                    this.initialize();
                }else{
                    this.reset();
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>


</style>
